import ConfigurationIcon from "../images/Configuration.svg";
import EnrolmentIcon from "../images/Enrolments.svg";
import HardwareIcon from "../images/Server.svg";
import UserIcon from "../images/User.svg";
import ReportsIcon from "../images/Reports.svg";
import MonitoringIcon from "../images/Monitoring.svg"
import { MenuItem } from "./MenuItem";

export const SideMenuItems: MenuItem[] = [
    {
        showIndexRoute: false,
        name: "Monitoring",
        route: "monitoring",
        icon: MonitoringIcon,
        badge: 0,
        children: [ // These menus are not shown alphabetically, order here is based on priority
            { name: "Dashboard", route: "dashboard", translationKey: "dashboard" }, // Users should land here first
            { name: "Transactions", route: "transactions", translationKey: "transactions" },
            { name: "Alarms", route: "alarms", translationKey: "alarms" },
            // { name: "CCTV", route: "cctv", translationKey: "cctv" }, // After v1
            // { name: "Floor Plans", route: "floor-plans", translationKey: "floorPlans" } // After v1
        ],
        translationKey: "monitoring"
    },
    {
        showIndexRoute: true,
        name: "Enrolments",
        route: "enrolment",
        icon: EnrolmentIcon,
        badge: 0,
        children: [
            { name: "Access Areas", route: "access-areas", translationKey: "accessAreas" },
            { name: "Access Time Patterns", route: "access-time-patterns", translationKey: "accessTimePattern" },
            { name: "Access Groups", route: "access-groups", translationKey: "accessGroups" },
            { name: "Access Profiles", route: "access-profiles", translationKey: "accessProfiles" },
            // { name: "Categories", route: "categories", translationKey: "categories" },
            { name: "Companies", route: "companies", translationKey: "companies" },
            { name: "Departments", route: "departments", translationKey: "departments" },
        ],
        translationKey: "enrolments"
    },
    {
        showIndexRoute: true,
        name: "Notifications",
        route: "notifications",
        icon: ReportsIcon,
        badge: 0,
        children: [],
        translationKey: "notifications"
    },
    {
        showIndexRoute: true,
        name: "Reports",
        route: "reports",
        icon: ReportsIcon,
        badge: 0,
        children: [
            { name: 'My Reports', route: 'my-reports', translationKey: "myReports" },
            { name: "Transaction", route: "transaction-report", translationKey: "transactions" },
            { name: "Time & Attendance", route: "time-attendance-report", translationKey: "timeAndAttendance" },
            { name: "Access Control", route: "access-control-report", translationKey: "accessControl" },
            { name: "System Setup", route: "system-setup-report", translationKey: "systemSetup" },
            { name: "Emergency & Safety", route: "emergency-safety-report", translationKey: "emergencyAndSafety" },
            { name: "Compliance", route: "compliance-report", translationKey: "compliance" },
        ],
        translationKey: "reports"
    },
    {
        showIndexRoute: true,
        name: "Hardware",
        route: "hardware",
        icon: HardwareIcon,
        badge: 0,
        children: [
            { name: "Buildings", route: "buildings", translationKey: "buildings" },
            { name: "Common Zones", route: "common-zones", translationKey: "commonZones" },
            { name: "Device Time Patterns", route: "device-time-patterns", translationKey: "deviceTimePatterns" },
            { name: "Doors", route: "doors", translationKey: "doors" },
            { name: "Floors", route: "floors", translationKey: "floors" },
            // { name: "Engine", route: "engine", translationKey: "engine" },
            { name: "Lifts", route: "lifts", translationKey: "lifts" },
            { name: "Presets", route: "presets", translationKey: "presets" },
            { name: "Reason Codes", route: "reason-codes", translationKey: "reasonCodes" },
            { name: "Time Triggered Actions", route: "time-triggered-actions", translationKey: "timeTriggeredActions" },
            { name: "Zones", route: "zones", translationKey: "zones" },
        ],
        translationKey: "hardware"
    },
    {
        showIndexRoute: false,
        name: "Operators",
        route: "operators",
        icon: UserIcon,
        badge: 0,
        children: [
            { name: "Logins", route: "logins", translationKey: "logins" },
            { name: "Permissions", route: "permissions", translationKey: "permissions" },
        ],
        translationKey: "operators"
    },
    {
        showIndexRoute: false,
        name: "Configuration",
        route: "configuration",
        icon: ConfigurationIcon,
        badge: 0,
        children: [
            { name: "Card Formats", route: "card-formats", translationKey: "cardFormats" },
            { name: "Events", route: "events", translationKey: "events" },
            { name: "Holidays", route: "holidays", translationKey: "holidays" },
            { name: "Messages", route: "messages", translationKey: "messages" },
            { name: "Operational Compliance", route: "operational-compliance", translationKey: "operationalCompliance" },
            { name: "Security Policies", route: "security-policies", translationKey: "securityPolicies" },
            { name: "Sites", route: "sites", translationKey: "sites" },
            { name: "System Accounts", route: "accounts", translationKey: "accounts" },
        ],
        translationKey: "configuration"
    },
    // {
    //     showIndexRoute: false,
    //     name: "Modules",
    //     route: "modules",
    //     icon: ModulesIcon,
    //     badge: 0,
    //     children: [
    //         { name: "Expiry Reasons", route: "expiry-reasons", translationKey: "expiryReasons" },
    //         // { name: 'Notifications', route: 'notifications', translationKey: "notifications" }, // After v1
    //         // { name: 'Milestone VMS', route: 'milestone-vms', translationKey: "milestoneVMS" }, // After v1
    //         // { name: 'Virtual IO', route: 'virtual-io', translationKey: "virtualIO" }, // After v1
    //         // { name: 'Card Designer', route: 'card-designer' }, // After v1
    //         { name: "Scheduled Tours", route: "scheduled-tours", translationKey: "scheduledTours" },
    //         { name: "Threat Level", route: "threat-level", translationKey: "threatLevel" },
    //     ],
    //     translationKey: "modules"
    // },
];
